import React from "react";
import Image from "next/image";
import Link from "next/link";
import { getReadingTime } from "@/helpers/readingTime";
import BlogCard_Thumbnail from "@/assets/image/BlogCard_Thumbnail.jpg";
import FormatDate from "@/utils/FormatDate"; // Make sure this is imported if you're using FormatDate
import { usePathname } from "next/navigation";



const BlogCards = ({ blogs }) => {

  const pathname = usePathname();
  const pathSegments = pathname.split("/").filter(Boolean);
  // Hide category on any page after /blog
  const hideCategoryTag = pathSegments[0] === "blog" && pathSegments.length > 1;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {blogs.map((blog) => {
        const blogDate = blog.blogDate;
        const updatedAt = blog.updatedAt;

        return (
          <div
            key={blog.id}
            data-blogcard-category={blog.category?.name}
            data-blogcard-id={blog?.id}
            className="
          group
          cursor-pointer
          bg-white
          overflow-hidden
          transition-transform
          duration-500
          ease-out
        "
          >
            <Link href={`/blog/${blog.slug}`}>
              {/* Cover Image */}
              <div className="relative w-full aspect-4/3 overflow-hidden">
                <Image
                  src={blog.cover?.url || BlogCard_Thumbnail}
                  alt={blog.cover?.alternativeText || blog.title}
                  fill
                  className="object-contain"
                />
              </div>
            </Link>

            {/* Blog Content */}
            <div className="pt-2 pb-2">
              {/* Category */}
              { blog.category?.name && (
                <span className="text-xs font-bold text-[#EB9100] bg-[#FFF0D7] px-3 py-2 mr-2 rounded capitalize">
                  {blog.category.name}
                </span>
              )}

              {/* SubCategory */}
              {blog.subcategories?.name && (
                <span className="text-xs font-bold text-[#2563EB] bg-[#DBEAFE] px-3 py-2 rounded capitalize">
                  {blog.subcategories.name}
                </span>
              )}

              {/* Title */}
              <Link href={`/blog/${blog.slug}`} className="pt-3 pb-1 flex flex-col gap-2">
                <h3 className="mt-3 text-[18px] font-bold text-black line-clamp-2 group-hover:text-[#005D82] min-h-14">
                  {blog.title}
                </h3>
              </Link>

              {/* Description */}
              <p className="text-[16px] text-gray-600 line-clamp-2 max-h-[30px]">
                {blog.description}
              </p>

              {/* Separator */}
              <hr
                className="my-3 border-0 h-[1.5px]"
                style={{ backgroundColor: "#616777", opacity: 0.2 }}
              />

              {/* Meta Info */}
              <div className="flex items-center gap-2 text-[12px] md:text-[13px] text-[#616777] mt-3">
                {blog.author?.name && (
                  <>
                    <span className="capitalize">{blog.author.name}</span>
                    <span>•</span>
                  </>
                )}

                {(blogDate || updatedAt) && (
                  <>
                    <span>
                      {blogDate ? FormatDate(blogDate) : FormatDate(updatedAt)}
                    </span>
                    <span>•</span>
                  </>
                )}

                <span>
                  {getReadingTime(
                    (blog.blocks || [])
                      .map((block) => block.Editor || block.body || "")
                      .join(" "),
                  )}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BlogCards;
